module.exports = __webpack_public_path__ + "static/lush_grass-03f6ea605d090c143ac5c899e4bae5b7.jpg";